import React, { useEffect, useState } from "react";
import {
  Table,
  Paper,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableSortLabel,
  CircularProgress,
  Box,
} from "@mui/material";
import { get } from "src/utils/networkUtils";
import { useLocation } from "react-router-dom";

const ParticipantTableList = () => {
  const location = useLocation();
  const [users, setUsers] = useState([]);
  const [orderBy, setOrderBy] = useState('prizeStatus');
  const [order, setOrder] = useState('desc');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadParticipants = async () => {
      try {
        setLoading(true);
        if (location.state?.raffleId) {
          const raffleId = location.state?.raffleId
          const raffle = await get(`/admin/raffles/${raffleId}`);

          setUsers(raffle?.participants || []);
        }
      } catch (error) {
        console.error("Failed to load participants:", error);
      } finally {
        setLoading(false);
      }
    };
    
    loadParticipants();
  }, [location.state?.raffleId]);

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const sortedUsers = React.useMemo(() => {
    if (!users) return [];
    
    return [...users].sort((a, b) => {
      let aValue = a[orderBy];
      let bValue = b[orderBy];
      
      if (orderBy === 'prizeStatus') {
        aValue = a.prizeStatus === 1 ? 1 : 0;
        bValue = b.prizeStatus === 1 ? 1 : 0;
      }
      
      if (order === 'asc') {
        return aValue > bValue ? 1 : -1;
      } else {
        return aValue < bValue ? 1 : -1;
      }
    });
  }, [users, order, orderBy]);

  return (
    <>
      <h2>Prize Draw Tickets</h2>
      {loading ? (
        <Box
          sx={{ display: "flex", justifyContent: "center" }}
          style={{ padding: 20 }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Ticket</TableCell>
                <TableCell>User Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Prize</TableCell>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === 'prizeStatus'}
                    direction={orderBy === 'prizeStatus' ? order : 'asc'}
                    onClick={() => handleRequestSort('prizeStatus')}
                  >
                    Is Winner
                  </TableSortLabel>
                </TableCell>
                <TableCell align="right"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedUsers?.map((row, index) => (
              <TableRow
                    key={index}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <TableCell component="th" scope="row">
                      {row.ticket}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.username}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row?.email ?? '-'}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.prize_title_en}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.prizeStatus === 1 ? 'Yes' : 'No'}
                    </TableCell>
                  </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
};

export default ParticipantTableList;
